import { create } from 'zustand';
import type { User } from '@supabase/supabase-js';
import type { City, VisitWithCity, Memory } from '../types/database';

interface AppState {
  // Auth
  user: User | null;
  setUser: (user: User | null) => void;

  // Cities
  cities: City[];
  setCities: (cities: City[]) => void;

  // Visits
  visits: VisitWithCity[];
  setVisits: (visits: VisitWithCity[]) => void;
  addVisit: (visit: VisitWithCity) => void;
  updateVisit: (visit: VisitWithCity) => void;

  // Memories
  memories: Memory[];
  setMemories: (memories: Memory[]) => void;
  addMemory: (memory: Memory) => void;

  // UI State
  selectedCity: City | null;
  setSelectedCity: (city: City | null) => void;

  // Loading states
  isLoadingCities: boolean;
  setIsLoadingCities: (loading: boolean) => void;
  isLoadingVisits: boolean;
  setIsLoadingVisits: (loading: boolean) => void;
}

export const useStore = create<AppState>((set) => ({
  // Auth
  user: null,
  setUser: (user) => set({ user }),

  // Cities
  cities: [],
  setCities: (cities) => set({ cities }),

  // Visits
  visits: [],
  setVisits: (visits) => set({ visits }),
  addVisit: (visit) => set((state) => ({ visits: [...state.visits, visit] })),
  updateVisit: (visit) => set((state) => ({
    visits: state.visits.map((v) => (v.id === visit.id ? visit : v)),
  })),

  // Memories
  memories: [],
  setMemories: (memories) => set({ memories }),
  addMemory: (memory) => set((state) => ({ memories: [...state.memories, memory] })),

  // UI State
  selectedCity: null,
  setSelectedCity: (city) => set({ selectedCity: city }),

  // Loading states
  isLoadingCities: false,
  setIsLoadingCities: (loading) => set({ isLoadingCities: loading }),
  isLoadingVisits: false,
  setIsLoadingVisits: (loading) => set({ isLoadingVisits: loading }),
}));
